import Mail from "@/domain/entities/emails/Email";
import { cn } from "@/lib/utils";

type MailTitleProps = {
    mail: Mail;
    isRead: boolean;
};

const MailTitle = ({ mail, isRead }: MailTitleProps) => (
    <p
        className={cn(
            "overflow-hidden text-ellipsis whitespace-nowrap text-left text-sm",
            !isRead && "font-bold",
        )}
    >
        {mail.subject}
    </p>
);

export default MailTitle;
